import { IMAGES } from "../../data/content";

export const Academy = () => (
  <section
    id="capitolo-4"
    data-testid="academy-section"
    className="py-24 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 border-b border-neutral-800"
  >
    <div className="mb-12">
      <h2 className="font-display text-3xl sm:text-4xl font-black uppercase text-white">
        Academy & Reparto Tecnico
      </h2>
      <p className="text-sm text-neutral-400 mt-1">
        Corsi di formazione piloti/navigatori, officina specializzata e store ufficiale.
      </p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
      <div data-testid="corsi-card" className="bg-neutral-900 border border-neutral-800 overflow-hidden">
        <img
          src={IMAGES.aulaFormazione}
          alt="Aula corsi Legend Team con banchi per piloti e navigatori"
          className="w-full aspect-[16/9] object-cover border-b border-neutral-800"
          loading="lazy"
        />
        <div className="p-8">
        <h3 className="font-display text-xl font-bold uppercase text-white mb-3">
          Corsi Piloti & Navigatori
        </h3>
        <p className="text-sm text-neutral-300 leading-relaxed mb-4">
          Il Legend Team si presenta come Motorsport Club e Scuola Guida: la velocità
          diventa significativa quando chi la pratica comprende il mezzo, il fondo, i
          propri limiti e le note. Lezioni in aula nella nostra sede e programmi per
          piloti e navigatori con istruttori che hanno vissuto le prove speciali dall'interno.
        </p>
        <a
          data-testid="corsi-cta"
          href="#contact"
          className="inline-block text-xs uppercase tracking-widest font-bold text-red-500 hover:text-red-400"
        >
          Richiedi programma corsi &rarr;
        </a>
        </div>
      </div>

      <div data-testid="officina-card" className="bg-neutral-900 border border-neutral-800 overflow-hidden">
        <img
          src={IMAGES.negozio}
          alt="Legend Store: sedili Sparco, cinture, scarpe e componenti racing"
          className="w-full aspect-[16/9] object-cover border-b border-neutral-800"
          loading="lazy"
        />
        <div className="p-8">
        <h3 className="font-display text-xl font-bold uppercase text-white mb-3">
          Officina & Legend Store
        </h3>
        <p className="text-sm text-neutral-300 leading-relaxed mb-4">
          Preparazione meccanica delle vetture da rally della società e negozio
          fisico con sedili, cinture, scarpe, volanti, turbo, componentistica racing
          e abbigliamento ufficiale Legend per piloti e tifosi.
        </p>
        <a
          data-testid="officina-cta"
          href="#contact"
          className="inline-block text-xs uppercase tracking-widest font-bold text-red-500 hover:text-red-400"
        >
          Contatta l'officina &rarr;
        </a>
        </div>
      </div>
    </div>

    <div
      data-testid="academy-visual"
      className="relative aspect-[21/9] border border-neutral-800 overflow-hidden"
    >
      <img
        src={IMAGES.cockpit}
        alt="Ford Sierra Cosworth Bastos della Legend Team in curva davanti al pubblico"
        className="absolute inset-0 w-full h-full object-cover opacity-70"
        loading="lazy"
      />
      <div className="absolute inset-x-0 bottom-0 p-6 bg-gradient-to-t from-neutral-950/90 to-transparent">
        <span className="mono-label text-xs text-neutral-300 uppercase">
          Legend Team Reparto Tecnico & Formazione
        </span>
      </div>
    </div>
  </section>
);
